export const tableLayout = {
  en: [
    {
      width: 240,
      label: "ID",
      dataKey: "id",
      type: "redirection",
      href: "/editor",
    },
    {
      width: 300,
      label: "Title",
      dataKey: "title",
    },
    {
      width: 80,
      label: "Featured",
      dataKey: "isFeatured",
      type: "toggle",
    },
    {
      width: 240,
      label: "URL",
      dataKey: "url",
      type: "link",
    },
    {
      width: 240,
      label: "Category",
      dataKey: "category",
      type: "tags",
    },
    {
      width: 90,
      label: "Deployed",
      dataKey: "deployedAt",
      type: "date",
    },
    {
      width: 160,
      label: "Actions",
      dataKey: "actions",
      type: "actions",
    },
  ],
  heb: [
    {
      width: 240,
      label: "מזהה",
      dataKey: "id",
      type: "redirection",
      href: "/editor",
    },
    {
      width: 300,
      label: "כותרת",
      dataKey: "title",
    },
    {
      width: 80,
      label: "מומלץ",
      dataKey: "isFeatured",
      type: "toggle",
    },
    {
      width: 120,
      label: "כתובת",
      dataKey: "url",
      type: "link",
    },
    {
      width: 240,
      label: "קטגוריה",
      dataKey: "category",
      type: "tags",
    },
    {
      width: 90,
      label: "פורסם",
      dataKey: "deployedAt",
      type: "date",
    },
    {
      width: 160,
      label: "פעולות",
      dataKey: "actions",
      type: "actions",
    },
  ],
};
